import React, { useState } from "react";
import { Button, IconButton, Image, Text, useColorModeValue, HStack, VStack, Link } from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
// @ts-ignore
import logo from "../../../assets/logo.png";

const HomeButtonMobil: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const backgroundColor = useColorModeValue("rgba(255, 255, 255, 0.9)", "rgba(0, 0, 0, 0.7)");
    const buttonHoverColor = useColorModeValue("blue.200", "blue.200");
    const buttonTextColor = useColorModeValue("#032c3d", "blue.700");

    const navLinks = [
        { label: t("navBaraboutUs"), href: "#aboutUs" },
        { label: t("navBarProduits"), href: "#Produits" },
        { label: t("navBarServices"), href: "#Services" },
        { label: t("navBarcontact"), href: "#contact" },
    ];

    const itemVariants = {
        hidden: { opacity: 0, y: -20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
        exit: { opacity: 0, y: -20, transition: { duration: 0.3 } },
    };

    return (
        <>
            <HStack spacing={2} align="center">
                <Button
                    aria-label="Reload Page"
                    onClick={() => window.location.reload()}
                    mr={4}
                    fontFamily="serif"
                    color="#032c3d"
                    fontWeight="bold"
                    fontSize="2xl"
                    variant="unstyled"
                    _hover={{ transform: "scale(1.1)" }}
                    transition="transform 0.2s ease-in-out"
                >
                    <HStack spacing={2} align="center">
                        <Image src={logo} alt="Logo" boxSize={8} />
                        <Text color={useColorModeValue("#003552", "blue.200")} fontSize="xl">
                            {t('Titre')}
                        </Text>
                    </HStack>
                </Button>

                <IconButton
                    aria-label="Toggle Menu"
                    icon={isOpen ? <FaChevronUp /> : <FaChevronDown />}
                    variant="ghost"
                    bg="null"
                    borderRadius="full"
                    border="2px solid transparent"
                    _hover={{ borderColor: "#032c3d" }}
                    onClick={toggleMenu}
                />
            </HStack>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95, y: -10 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.95, y: -10 }}
                        transition={{ duration: 0.25, ease: "easeOut" }}
                        style={{
                            position: "absolute",
                            top: "64px",
                            left: "10px",
                            zIndex: 999,
                            width: "90%",
                        }}
                    >
                        <VStack
                            spacing={4}
                            align="start"
                            bg={backgroundColor}
                            p={5}
                            boxShadow="lg"
                            rounded="xl"
                        >
                            {navLinks.map((link, index) => (
                                <motion.div
                                    key={link.label}
                                    initial={{ opacity: 0, x: -15 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: -15 }}
                                    transition={{ delay: index * 0.08, duration: 0.3 }}
                                    style={{ width: "100%" }}
                                >
                                    <Button
                                        as={Link}
                                        href={link.href}
                                        w="100%"
                                        textAlign="left"
                                        variant="ghost"
                                        color={buttonTextColor}
                                        fontSize="lg"
                                        fontWeight="medium"
                                        _hover={{
                                            bg: buttonHoverColor,
                                            color: "white",
                                            transform: "scale(1.05)",
                                            transition: "all 0.2s ease-in-out",
                                        }}
                                    >
                                        {link.label}
                                    </Button>
                                </motion.div>
                            ))}
                        </VStack>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};

export default HomeButtonMobil;
